import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import { generateTag } from 'utils/helpers/fetch';
import * as R from 'ramda';

const getUrl = R.concat('terminal-locator/');

const terminalDetailsEndpoints = loadingManagementApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    getTerminalDetails: query({
      providesTags: generateTag('Terminal', 'terminalId'),
      query: ({ terminalId }) => ({
        params: { terminalId },
        url: getUrl('get-terminal-details'),
      }),
    }),
    setEditNotifications: mutation({
      query: params => ({
        method: 'POST',
        params,
        url: getUrl('edit-notification'),
      }),
    }),
  }),
});

/* eslint-disable import/prefer-default-export */
export const { useGetTerminalDetailsQuery, useSetEditNotificationsMutation } =
  terminalDetailsEndpoints;
